<template>
  <div id="app">
    <!-- <music v-if="showMusic" ></music> -->
    <router-view  v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  // 刷新当前页
   provide (){
     return {
       reload:this.reload
     }
  },
  data(){
    return{
      isRouterAlive:true,// 刷新当前页
      showMusic:false,
      deepPath:['/anniversary_home','/page1','/page2','/page3','/page4','/page6','/page7','/page8','/page9','/page10','/page11','/page12','/page13'],
    }
  },
  methods:{
    // 刷新当前页
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
  components:{
    music:()=>import ('./components/anniversary/component/music')
  },
  beforeDestroy(){},
  watch:{
    $route(to,from){
      let pathTo=to.path
      if(this.deepPath.includes(pathTo)){
        this.showMusic=true
      }else{
        this.showMusic=false
        // this.$refs.music.playMusic()
      }
     
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
 
}
a{
    text-decoration: none;
    color:#ffff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue